/**
 * Formatting for Brazilian currency / decimals in contract text and live preview.
 * Form state stores user-entered strings (comma decimal, optional thousand dots in display mask).
 */

function parseBrlStringToNumber(value) {
  if (value == null || String(value).trim() === "") return NaN;
  const s = String(value).replace(/\./g, "").replace(",", ".");
  return parseFloat(s);
}

/** Output for document: "1.234,56" (no R$ prefix; template adds R$ where needed). */
export function formatBrlCurrencyForDoc(value) {
  if (value == null || String(value).trim() === "") return "";
  const n = parseBrlStringToNumber(value);
  if (Number.isNaN(n)) return String(value);
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

/** Percent / juros: comma decimal, up to 4 fraction digits. */
export function formatDecimalBrForDoc(value) {
  if (value == null || String(value).trim() === "") return "";
  const s = String(value).replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  if (Number.isNaN(n)) return String(value);
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(n);
}
